// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-mediumOnWide-button-eb8a6dfc","buttonLoading":"skins-mediumOnWide-buttonLoading-df9935c5"};